String.prototype.ucfirst = String.prototype.ucfirst || function (n) {
  return this.charAt(0).toUpperCase() + this.slice(1)
};
String.prototype.dashcase = String.prototype.dashcase || function (n) {
  //return this.toLowerCase().replace(/ /g, '-');

  let str = this;
  str = this.toLowerCase();
  var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

  for (var i = 0; i < toReplace.length; ++i) { str = str.replace(toReplace[i], ""); }

  str = str.replace(/\W+/g, "-");
  if (str.charAt(str.length - 1) == "-") { str = str.replace(/-+\z/, ""); }
  if (str.charAt(0) == "-") { str = str.replace(/\A-+/, ""); }

  return str;
};

class HJ {
  constructor() {
    window._HJ = window._HJ || { Global: HJ };
  }

  init() {
    if (this && typeof window._HJ[this.constructor.name] == 'undefined') {

      window.addEventListener('DOMContentLoaded', (e) => {
        this.config = { ...window._HJ_CONFIG, ...this.config };
        this.cache_dom();
        this.load();
        this.bind();
        this.loaded();

        window._HJ[this.constructor.name] = this;
        this.ready();
        console.info(`Initialised: ${this.constructor.name}`);
      });
    }
  }

  reinit() {
    this.unbind();
    this.cache_dom();
    this.load();
    this.bind();
    this.loaded();
  }

  dom = {};

  config = {};

  cache = {};

  load() { }

  loaded() { }

  bind() { }

  unbind() { }

  ready() { }

  cache_dom() {
    if (typeof jQuery == 'undefined') { return; }

    $.each(this.dom, (k, v) => {
      if (typeof v == 'function' || k.includes('$')) { return true; }
      if (typeof this.dom.container != 'undefined' && k[0] == '_') {
        k = k.replace('_', '');
        v = this.dom.container + ' ' + v;
      }
      this.dom['$' + k] = $(v);
    });
  }

  get current_product() {
    if (this.cache.current_product) {
      return this.cache.current_product;
    }

    let p = this.config.product;
    p.options_with_values = p.options.map((opt, index) => {
      return {
        name: opt,
        values: [...new Set(p.variants.map(v => v.options[index]))],
      };
    });

    this.cache.current_product = p;
    return this.cache.current_product;
  }
} new HJ();

class SiteCart extends HJ {

  constructor() {
    super();
    this.init();
  }

  dom = {

    container: 'cart-drawer',
    _line_items: 'table .cart-item',
    _input_qty: 'quantity-input .quantity__input',
    _remove_btn: 'cart-remove-button button',
    _clear_all: '[data-el="cart--clear"]',

    header: '.shopify-section.section-header',
    header_icon_count: '.header__icon--cart',

  };

  config = {
    header_hidden_class: 'shopify-section-header-hidden',
    loading_icon: `<div class="spinner-grow" style="width: 13px; height: 13px; margin: -1.05px;" role="status"><span class="sr-only"></span></div>`
  };

  cache = {};

  load() {
    this.config.sections = this.dom.$container[0].getSectionsToRender().map((section) => section.id).concat('cart').join(',');
  }

  bind() {

    this.dom.$container.on('click', this.dom._clear_all, (e) => {
      fetch('/cart/clear').then(() => { location.reload(); });
    });

    this.dom.$container.on('change keyup', this.dom._input_qty, (e) => {
      let $this = $(e.target);
      let $container = $this.closest(this.dom._line_items);

      // EXIT IF NOT A MAIN PRODUCT
      if (!$container.data('group').includes('#')) { return; }

      const group_id = $container.data('group').replace(/\D/g, '');

      $container.siblings(`[data-group*="${group_id}"]`).each((k, el) => {
        const $input = $(el).find(this.dom._input_qty);
        $input.val($this.val() * parseInt($input.attr('step')));
      });
    });

this.dom.$container.on('click', this.dom._remove_btn, (e) => {
  e.preventDefault();

  const $button = $(e.currentTarget);
  const $container = $button.closest(this.dom._line_items);

  const clickedKey = $container.data('key');
  const clickedGroup = String($container.data('group') || '');
  const groupId = clickedGroup.replace(/\D/g, '');

  $.getJSON('/cart.js')
    .done((cart) => {
      const items = {};

      // Always remove the clicked cart item
      if (clickedKey) {
        items[clickedKey] = 0;
      }

      // Remove every fabric and add-on from the same product group
      cart.items.forEach((item) => {
        const itemGroup = String(item.properties?._group || '');
        const itemGroupId = itemGroup.replace(/\D/g, '');

        if (groupId && itemGroupId === groupId) {
          items[item.key] = 0;
        }
      });

      this.func.update(items);
    })
    .fail((error) => {
      console.error('Could not read cart:', error);
    });
});

this.dom.$container.on(
  'click',
  'button[type="submit"][name="update"]',
  (e) => {
    const $this = $(e.currentTarget);
    $('#' + $this.attr('form')).attr('reload', true);
  }
);

this.dom.$container.on('submit', 'form', (e) => {
  e.preventDefault();

  const $this = $(e.currentTarget);

  this.dom.$container
    .find('button[type="submit"]')
    .prop('disabled', true)
    .html(this.config.loading_icon);

  const items = {};

  this.dom.$container.find(this.dom._line_items).each((k, el) => {
    const $lineItem = $(el);

    items[$lineItem.data('key')] = $lineItem
      .find(this.dom._input_qty)
      .val();
  });

  this.func.update(items, $this.is('[reload]') ? null : () => {
    window.location.href = '/checkout';
  });

  return false;
});

  }

  loaded() {

    if (window.location.hash == '#cart') {
      this.dom.$container.get(0).open();
    }

  }

  func = {

    reload: () => {
      delete this.cache.silent_update; // do nothing
      return $.ajax({
        method: 'get',
        url: '/cart',
        data: { sections: this.config.sections },
        success: (res) => {
          this.func.update_ui({
            sections: res
          });
        }
      });
    },

    add: (items, cb = null) => {
      this.cache.silent_update = false;
      return $.ajax({
        method: 'post',
        url: '/cart/add.js',
        data: { items: items, sections: this.config.sections },
        dataType: 'json',
        success: cb ? cb : this.func.update_ui,
        error: (e) => alert(e.responseJSON?.message),
      });
    },

    update: (items, cb = null) => {
      delete this.cache.silent_update; // do nothing
      return $.ajax({
        method: 'post',
        url: '/cart/update.js',
        data: { updates: items, sections: this.config.sections },
        dataType: 'json',
        success: cb ? cb : this.func.update_ui,
      });
    },

    update_attr: (attr, cb) => {
      this.cache.silent_update = true;
      return $.ajax({
        method: 'post',
        url: '/cart/update.js',
        data: { attributes: attr, sections: this.config.sections },
        dataType: 'json',
        success: cb ? cb : this.func.update_ui,
      });
    },

    update_ui: (res) => {

      if (res.sections.cart) {
        this.cache.cart = JSON.parse($(res.sections.cart).html());

        if (this.cache.cart.item_count == 0) {
          this.dom.$container.get(0).close();
        }

        this.dom.$header.removeClass(this.config.header_hidden_class);
        this.dom.$header_icon_count.toggleClass('d-none', this.cache.cart.item_count == 0);
        this.dom.$container.toggleClass('is-empty', this.cache.cart.item_count == 0);

      }

      this.dom.$container[0].renderContents(res);

      if (this.cache.silent_update === true) {
        this.dom.$container[0].close();
      } else if (this.cache.silent_update === false) {
        this.dom.$container[0].open();
      }
    }

  };

} new SiteCart();

class HardCodedValues {

  static getDataset(dataType, data) {
    switch (dataType) {
      case 'brand':
        if (window.location.href.includes('/pages/') && window.location.href.includes('bassinet-liner')) {
          data = Util.getData().brands.filter(b => Object.keys(b.models).join(' ').includes('bassinet')).map(x => x.title);
        }
        console.log('HardCodedValues class is called for ' + dataType);
        break;
      case 'model':
        if (window.location.href.includes('/pages/') && window.location.href.includes('bassinet-liner')) {
          data = data.slice(data.findIndex(x => x.toLowerCase().includes('--- bassinet liner')) + 1);
        }
        console.log('HardCodedValues class is called for ' + dataType);
        break;

    }
    return data;
  }

  static isFrontFabric(context) {
    // Expects context to be a String
    // Check if "context" contains "Front Fabric".
    return context?.toLowerCase().includes('front fabric');
  }

  static isBackFabric(context) {
    // Expects context to be a String
    // Check if "context" contains "Back Fabric".
    return context?.toLowerCase().includes('back fabric');
  }

  static isFabric(context) {
    // Expects context to be a String
    // Check if "context" is equal to "fabric".
    // OR contains "fabric".
    return context.toLowerCase() === 'fabric' || context.toLowerCase().includes('fabric');
  }

  static isDoubleLiner(context) {
    // Expects context to be a Product Object
    // Check if "tag" in "context" contains "double-liner".
    return context?.tags.map(x => x.dashcase()).includes('double-liner');
  }

  static isPramLiner(context) {
    // Expects context to be a Product Object
    // Check if "type" in "context" contains "pram-liner".
    return context.type.dashcase() == 'pram-liner';
  }
  static isPramAccessory(context) {
    // Expects context to be a Product Object
    // Check if "type" in "context" is "pram-accessory".
    return context?.type?.dashcase() == 'pram-accessory';
  }

  static getFabricDefaultValue() {
    return 'Select Fabric';
  }

  static getFabricsCollection(context) {

    // Minky dots
    const MinkyDotsProd = Util.getDataset('product')?.tags.map(x => x.dashcase()).includes('minky-dot-back-fabric');
    if (MinkyDotsProd && context.toLowerCase().includes('front fabric')) {
      return 'front-fabrics';
    }
    if (MinkyDotsProd && context.toLowerCase().includes('back fabric')) {
      return 'minky-dots';
    }

    // Liner products
    if (context.toLowerCase().includes('front fabric')) {
      return 'front-fabrics';
    }
    if (context.toLowerCase().includes('liner')) {
      return 'all-fabrics';
    }

    return 'all-fabrics';
  }

}

class Util { // Utilities

  static getData() {
    return JSON.parse(document.querySelector('#alpinejs-data').innerHTML);
  }

  static getDataset(dataType, context) {

    const buildData = (dataType, context) => {
      this.appData = this.getData();
      switch (dataType) {
        case 'product':
          return this.appData.product;
        case 'selected-brand':
          return this.appData.brands.filter(x => x.title == context.brand).shift();
        case 'selected-model-product':
          const b = this.getDataset('selected-brand', context);
          for (const [product_handle, models] of Object.entries((b && b.models) || {})) {
            if (models.includes(context.model)) {
              return b.products[product_handle];
            }
          }
          return null;
        case 'brand':
          const x = this.appData.brands.filter(x => (this.appData.product && x.target_products.length && x.models[this.appData.product.handle]));
          return (x.length ? x : this.appData.brands).map(x => x.title);
        case 'model':
          let p = 0;
          let formattedCollection = context.brand
            ? context.brand.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
            : '';
          let brand = this.appData.brands.find(x => x.title && x.title === context.brand);



          if (!brand && formattedCollection) {
            brand = this.appData.brands.find(x => x.title === formattedCollection);
          }
          if (!brand) {
            console.warn('Brand not found for model selection.');
            return [];
          }

          const product_type = Util.getURLParameter('target') || (() => {
            // Fallback to extract the product handle from the current URL
            const match = window.location.pathname.match(/\/products\/([^/]+)/);
            return match && match[1]?.includes('liner') ? match[1] : null;
          })();

          if (product_type) {
            if (product_type === "pram-liner") {
              const targetProducts = brand?.target_products || [];
              const modelTypes = ["single-pram-liner", "double-pram-liner"];
              let result = [];

              modelTypes.forEach((type, index) => {
                // Add header for the current product type if it exists
                if (targetProducts[index] && modelTypes.includes(targetProducts[index].handle)) {
                  result.push(`--- ${targetProducts[index].title.toUpperCase()} ---`);
                }
                // Add models for the current product type
                result.push(...(brand.models[type] || []));
              });
              return result;
            }

            return brand.models[product_type];
          }
const groupIndex = context.product_type !== undefined && context.product_type !== ''
  ? parseInt(context.product_type)
  : null;

if (groupIndex !== null) {
  const groups = [];
  let current = [];
  for (const m of brand.all_models) {
    if (!m) { groups.push(current); current = []; }
    else { current.push(m); }
  }
  groups.push(current);
  return groups[groupIndex] || [];
}

return brand?.target_products.length == 1
  ? brand.all_models
  : [
    ...[`--- ${brand?.target_products[0]?.title.toUpperCase()} ---`], // prepend product[0]
    ...brand?.all_models.map(x => x || `--- ${brand?.target_products[++p]?.title.toUpperCase()} ---` || '') // replace any empty value with option title
  ];

        case 'pattern':
          return this.appData.patterns;
        case 'color':
          return this.appData.colors;
      }
      return [];
    };

    //return buildData();
    //console.log(buildData(dataType, context));
    return HardCodedValues.getDataset(dataType, buildData(dataType, context));
  }

  static uid() {
    return (Math.floor(Math.random() * (9999999 - 1000000 + 1) + 1000000)).toString();

    var a = (Math.random() * 46656) | 0;
    var b = (Math.random() * 46656) | 0;
    return ("000" + a.toString(36)).slice(-3) + ("000" + b.toString(36)).slice(-3);
  }

  static money(cents, format) {
    /* Shopify */
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    let value = '';
    let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || Shopify.money_format || "${{amount}}");

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number / 100.0).toFixed(precision);

      let parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);

  }

  static buildUrlParams(inputs) {
    const params = new URLSearchParams();
    for (const [k, v] of Object.entries(inputs)) {
      // ignore hidden input
      if (k[0] != '_' && v) params.set(k, v);
    }
    return '?' + params.toString();
  }

  static setURL(url) {
    window.history.replaceState(null, '', url);
    return true;
  }

  static setURLVars(k, v) {
    const params = new URLSearchParams(window.location.search);
    k && v && params.set(k, v);
    k && !v && params.delete(k);
    return Util.setURL( window.location.href.split('?').shift() + '?' + params.toString() );
  }

  static getURLParameter(param) {
    const params = new URLSearchParams(window.location.search);
    return params.get(param);
  }
}

function ColProdPreselect(data) {
  return {
    componentID: (Math.random() + 1).toString(36).substring(7),
    appData: JSON.parse(document.querySelector('#alpinejs-data').innerHTML),

    const: {
      prefix: {
        color: '_colour:',
        pattern: '_pattern:',
      }
    },

    input: {
      brand: '',
      model: '',
      pattern: '',
      color: '',
      fabric: '',

      // hidden when starts with "_"
      _collection: '',
      _tag: '',
      selectedFabric: null, // To store the selected fabric
      provideOwnFabric: false, // To handle custom fabric checkbox
    },

    /* INHERIT */
    getDataset(x) { return Util.getDataset(x, this.input); },

    isDisabled(dataType) {
      switch (dataType) {
        case 'submit':
          return (location.pathname !== '/pages/shop-by-fabric' && location.pathname !== '/pages/customise-your-bassinet-liner-fabric') && (this.input.brand == ''
            || (this.input.brand == '' && this.input.model == '' && this.input.pattern == '' && this.input.color == ''));
        case 'model':
          return this.input.brand == '';
      }
      return false;
    },

    handleFormSubmit(event) {
      event.preventDefault();

      if (window.location.pathname.includes('/collections/')) {
        // Redirect to designated pdp
        const b = this.getDataset('selected-brand');
        for (const [product_handle, models] of Object.entries(b.models)) {
          if (models.includes(this.input.model)) {
            window.location.href = '/products/' + product_handle + window.location.search;
          }
        }
      }

      const actionUrl = document.querySelector('.shop-by__selector')?.getAttribute('action');
      if (actionUrl && !window.location.pathname.includes('/collections/')) {
        const target = window.location.href.includes('bassinet-liner') ? 'bassinet-liner' :
          window.location.href.includes('pram') ? 'pram-liner' : null;
        const url = target ? `${actionUrl}${Util.buildUrlParams(this.input)}&target=${target}` : `${actionUrl}${Util.buildUrlParams(this.input)}`;
        window.location.href = url;
      }
    },

    isVisible(dataType) {
      switch (dataType) {
        case 'brand':
          return !this.appData.brands.map(x => x.title.dashcase()).includes(this.input._collection.dashcase());
        case 'model':
        //return this.getDataset('model').length > 0;
      }
      return true;
    },

    buildDynamicUrl(dataType, d) {
      switch (dataType) {
        case 'color':
          return '/collections/' + this.input._collection + '/' + this.const.prefix.color + d + Util.buildUrlParams(this.input);
        case 'pattern':
          return '/collections/' + this.input._collection + '/' + this.const.prefix.pattern + d + Util.buildUrlParams(this.input);
        case 'brand':
          return '/collections/' + d + '/' + this.input._tag + Util.buildUrlParams(this.input);
      }
      return '/' + Util.buildUrlParams(this.input);
    },

    init() { // init() is automatically called by AlpineJS
      window._AlpineJS = window._AlpineJS || {};
      window._AlpineJS.ColProdPreselect = this.$data;

      this.$nextTick(() => {
        this.syncDataFromUrl();
        //this.updateUrl();

        const customButton = document.getElementById('custom-button');
        if (window.location.pathname.includes('/collections/')) {
          customButton.textContent = 'Start Designing';
        }
      });
    },

    syncDataFromUrl() {
      const urlData = new URLSearchParams(window.location.search);

      if (window.location.pathname.includes('/collections/')) {
        this.input._collection = window.location.pathname.split('/')[2].toLowerCase() || '';
        this.input._tag = window.location.pathname.split('/')[3] || '';
      }

      const brand = this.getDataset('brand').find(x => x.dashcase() == this.input._collection);
      this.input.brand = brand ? brand : (urlData.get('brand') || '');

      const model = this.getDataset('model').find(x => x == urlData.get('model'));
      this.input.model = model ? urlData.get('model') : '';

      const patterns = this.getDataset('pattern');
      this.input.pattern = patterns.map(x => x.toLowerCase()).includes(this.input._tag.replace(this.const.prefix.pattern, '').toLowerCase())
        ? this.input._tag.replace(this.const.prefix.pattern, '')
        : (urlData.get('pattern') || '');

      const colors = this.getDataset('color');
      this.input.color = colors.map(x => x.toLowerCase()).includes(this.input._tag.replace(this.const.prefix.color, '').toLowerCase())
        ? this.input._tag.replace(this.const.prefix.color, '')
        : (urlData.get('color') || '');
    },

    onInputChanged() {
      // just an alias
      this.updateUrl();
    },

    updateUrl() {
      //Set Browser URL
      const urlParams = Util.buildUrlParams(this.input);
      Util.setURL(window.location.pathname + urlParams);

      let targetProduct = null;
      let brand = Util.getDataset('selected-brand', this.input);
      brand && Object.keys(brand.models).forEach(m => {
        brand.models[m].includes(this.input.model) && (targetProduct = m);
      });
      targetProduct = targetProduct ? targetProduct : Object.keys(brand.models)[0];
      this.updateProductCardLinks(this.input);
    },

    updateProductCardLinks(params) {
      const newParams = new URLSearchParams(Util.buildUrlParams(params));
      document.querySelectorAll('a[data-href]').forEach((el) => {
        const url = new URL(el.href);
        newParams.forEach((value, key) => {
          url.searchParams.set(key, value);
        });
        el.href = url.toString();
      });
    }
  };
}

function ProdBuilder() {
  return {

    componentID: (Math.random() + 1).toString(36).substring(7),

    cache: {
      product: null,
      products: {},
      modal: null,
      active_tab: 1,
      max_tab: 1,
      modal_content: '',
      focused_input: '',
      fabric_selector_count: 1,
      cart: [],
      cart_sum: '',
    },

    input: {
  brand: 'Brand',
  model: 'Model',
  product_type: '',
},

    init() { // init() is automatically called by AlpineJS
      window._AlpineJS = window._AlpineJS || {};
      window._AlpineJS.ProdBuilder = this.$data;

      this.cache.product = Util.getDataset('product');
      if (HardCodedValues.isDoubleLiner(this.cache.product)) {
        this.cache.fabric_selector_count = 2;
      }

      this.cache.max_tab = parseInt(this.$el.querySelector('.steps-buttons .next-button')?.dataset.stepCount);

      this.buildCart();
      
      this.$nextTick(() => {
        this.syncDataFromUrl();
        this.buildCart();
        this.upgradePage();
        
        !this.isStepNextDisabled()
          && this.cache.product.handle == (this.getMainProd()).handle
          && this.cache.max_tab > 1
          && (this.cache.active_tab = 2);

        this.cache.active_tab == 2 && window.scrollTo({
          top: document.querySelector('[data-product-builder]').offsetTop - 50,
          behavior: "smooth",
        });
      });
    },


    /* INHERIT */
    getDataset(x) { return Util.getDataset(x, this.input); },

    onInputChanged(input) {
      const smp = this.getDataset('selected-model-product');

      switch (input) {
  case 'product_type':
    this.input.model = '';
    Util.setURL(window.location.pathname + Util.buildUrlParams(this.input));
    break;
  case 'brand':
    this.input.model = '';
    this.input.product_type = '';
    Util.setURL(window.location.pathname + Util.buildUrlParams(this.input));
    break;

        case 'model':
          Util.setURL(window.location.pathname + Util.buildUrlParams(this.input));
          this.cache.fabric_selector_count = 1;
          if (HardCodedValues.isDoubleLiner(smp)) {
            this.cache.fabric_selector_count = 2;
          }
        case 'addon':
          //if (HardCodedValues.isDoubleLiner(smp)) { console.log('Double'); }
          break;
      }
      this.buildCart();
    },

    isVisible() {
      return true;
    },
    /* ####### */

    onStepPrev() {
      if (this.cache.active_tab == 1) { return; }
      this.cache.active_tab--;
    },

    onStepNext() {
      let mainProd = this.getMainProd();

      if(this.cache.active_tab == 1 && mainProd.handle != this.cache.product.handle) {
        location.href = '/products/' + mainProd.handle + Util.buildUrlParams(this.input);
      } else {
        this.cache.active_tab++;
      }
    },

    isStepNextDisabled() {

      let isDisabled = false;

      const defaultFabric = HardCodedValues.getFabricDefaultValue();
      if (this.cache.max_tab > 1) { // && this.cache.active_tab == 1
        isDisabled =
          this.input.brand == ''
          || this.input.model == ''
          || this.input["Liner 1 - Front Fabric"] === defaultFabric
          || this.input["Liner 1 - Back Fabric"] === defaultFabric
        ;
        if (this.cache.fabric_selector_count == 2) {
          isDisabled =
            isDisabled
            || this.input["Liner 2 - Front Fabric"] === defaultFabric
            || this.input["Liner 2 - Back Fabric"] === defaultFabric
          ;
        }
      }

      if(!this.input.brand || !this.input.model) {
        isDisabled = true;
      }
      
      return isDisabled;
    },

    isAddToCartInvalid() {
      const defaultFabric = HardCodedValues.getFabricDefaultValue();
      return this.input["Front Fabric"] === defaultFabric || this.input["Back Fabric"] === defaultFabric;
    },

    upgradePage() {
      const stepsContent = document.querySelector('.steps-content');
      const variantSelects = document.querySelector('variant-selects');
      if (stepsContent && variantSelects) { console.log('Upgrading page...');
      
        stepsContent.insertAdjacentElement('afterend', variantSelects);

        this.$el.closest('product-info').addEventListener('product-option-changed', this.buildCart.bind(this));
      }
    },

    onFabricSelect(input = '') {
      this.cache.focused_input = input;
      this.modal(`/collections/${HardCodedValues.getFabricsCollection(input)}?section_id=main-collection-product-grid`, res => `
        <div
          @click="window._AlpineJS.ProdBuilder.onInnerModalClick"
          class="prod-builder--modal
            ${HardCodedValues.isFrontFabric(this.cache.focused_input) ? 'hide-price' : ''}
          "
        >${res}</div>`,
        true
      );
    },

    onInnerModalClick(e) {
      const _this = window._AlpineJS.ProdBuilder;
      if (e.target.id.includes('CardLink') || e.target.classList.contains('full-unstyled-link')) {
        e.preventDefault();

        if (_this.getDataset('selected-model-product')) {
          // set text value
          _this.input[_this.cache.focused_input] = e.target.href.split('/products/').pop().split('?').shift();
          // redirect
          _this.modalLoadingScreen();
          location.href = e.target.href.split('?').shift() + Util.buildUrlParams(_this.input);
          return;
        }

        // set text value
        _this.input[_this.cache.focused_input] = e.target.innerText.trim();

        // hide modal
        this.toggle(false);

        // update image
        document
          .querySelector(`input[name*="${_this.cache.focused_input}"] + .swatch-image img`)
          .src = e.target.closest('.card').querySelector('img').src;

        _this.buildCart();
        Util.setURL(window.location.pathname + Util.buildUrlParams(_this.input));
      }

      if (e.target.classList.contains('pagination__item')) {
        e.preventDefault();
        _this.modal(e.target.href + '&section_id=main-collection-product-grid', res => `
          <div
            @click="window._AlpineJS.ProdBuilder.onInnerModalClick"
            class="prod-builder--modal
            ${HardCodedValues.isFrontFabric(_this.cache.focused_input) ? 'hide-price' : ''}
            "
          >${res}</div>`,
          true
        );
      }

    },

    onAddToCart() {
      _HJ.SiteCart.func.add([...this.cache.cart].reverse());
    },

    modal(url, cb, reload = false) {
      const m = window._AlpineJS.SiteModal;

      if (!url && !cb && this.cache.modal_content) {
        m.content = this.cache.modal_content;
        m.toggle(true);
      } else if (url && cb) {
        if (!this.cache.modal_content || reload) {
          this.modalLoadingScreen();
        }
        m.toggle(true);
        return fetch(url)
          //.then(res => res.json())
          .then(res => res.text())
          .then((res) => {
            this.cache.modal_content = cb ? cb(res) : res;
            m.content = this.cache.modal_content;
          });
      } else {
        m.toggle(false);
      }
    },

    modalLoadingScreen(url, cb, reload = false) {
      const m = window._AlpineJS.SiteModal;
      m.toggle(true);
      m.content = '<div class="modal__loading_screen"><h1 class="text-center w-100">&nbsp;Loading...</h1>';
    },

    getMainProd() {
      return (
        HardCodedValues.isFabric(this.cache.product.type)
        && this.getDataset('selected-model-product', this.input)
      )
      || this.cache.product;
    },

    buildCart() {

      let uid = Util.uid();
      const prodInfo = document.querySelector('product-info');

      let mainProd = this.getMainProd();
      let variant = prodInfo.getSelectedVariant(prodInfo) || mainProd.variants[0];
      let prod = null;

      this.cache.cart = [{
        id: variant.id,
        quantity: 1,
        properties: {
          _group: '#' + uid,
        },
        info: {
          title: mainProd.title,
          price: variant.price,
          required: true,
        },
      }];

      // Add FABRICS
      for (const [k, v] of Object.entries(this.input)) {
        // Ignore if key == value
        if (k.ucfirst() == v) { continue; }
        // Ignore if input is null
        if (!v && !document.querySelector(`[name="properties['${k}']"]`)) { continue; }
        // Ignore if Fabric value is == default
        if (v == '' || v == HardCodedValues.getFabricDefaultValue()) { continue; }
        // Ignore if Front Fabric
        //if (HardCodedValues.isFrontFabric(k)) { continue; }
        
        // If NOT Fabric, add as prop
        if (!HardCodedValues.isFabric(k)) {
          this.cache.cart[0].properties[k.ucfirst()] = this.cache[k] || v;
          continue;
        }
        
        prod = this.cache.products[v.dashcase()];
        if (typeof prod === 'undefined') {
          fetch(`/products/${v.dashcase()}.json`, { headers: { 'Content-Type': 'application/json' } })
            .then(r => r.json())
            .then(r => {
              this.cache.products[v.dashcase()] = r.product;
              this.buildCart();
            })
            .catch(e => this.cache.products[v.dashcase()] = null);

        } else if (typeof prod !== 'undefined' && prod !== null) {
          /*
            Expected variant pricess
            - 0: $0
            - 1: $n
          */
          variant = prod.variants[0];
      if (HardCodedValues.isBackFabric(k) && prod.variants[1] && !HardCodedValues.isPramAccessory(mainProd)) {
            variant = prod.variants[1];
          }

          this.cache.cart.push({
            id: variant.id,
            quantity: 1,
            properties: { _group: '*' + uid, 'Option for': k},
            info: {
              title: prod.title,
              price: parseFloat(variant.price) * 100,
              required: true,
              type: k
            },
          });
        }
      }

      // Add ADDONS
      document.querySelectorAll('input[name*="properties"]:checked').forEach((el, k) => {

        const data = JSON.parse(el.dataset.productJson);
        //if (data.price == 0 && data.type == '') {
        //if (data.price == 0) {
        if (false) { // Ignore this block, add product regardless of price
          const name = el.name.match(/\[(.*?)\]/)[1];
          switch (el.type) {
            case 'radio':
              this.cache.cart[0].properties[name] = data.title;
              break;
            case 'checkbox':
              this.cache.cart[0].properties[name + ' ' + k] = data.title;
              break;
          }
        } else {
          //const qty = el.parentNode.querySelector('quantity-input input')?.value || 1;
          const smp = this.getDataset('selected-model-product');
          const qty = smp && HardCodedValues.isDoubleLiner(smp) && data.required ? 2 : 1;
          const prop = this.cache.fabric_selector_count > 1 && !data.required && Object.entries(this.input)
            .filter(x => x[0].includes(el.getAttribute('data-group-name')))
            //.forEach(x => prop[x[0]] = x[1])
            .length
            ? {'Addon for': el.getAttribute('data-group-name')}
            : {}
          ;
          this.cache.cart.push({
            id: data.vid,
            quantity: qty,
            properties: {...prop, ...{
              _group: (data.required ? '*' : '+') + uid,
              _min_unit: qty,
            }},
            info: data,
          });
        }

      });

      this.cache.cart_sum = Util.money(this.cache.cart.map(x => x.quantity * x.info.price).reduce((a, b) => a + b, 0));
      this.update_external_ui();
      return this.cache.cart;

    },

    update_external_ui() {

      const price_el = document.querySelector('[id^="ProductInfo"] .price-item--regular');
      if(this.cache.cart_sum && price_el) {
        price_el.innerHTML = this.cache.cart_sum;
        price_el.style.display = 'block';
      } else {
        price_el.style.display = 'none';
      }

    },

    syncDataFromUrl() {
      const urlData = new URLSearchParams(window.location.search);

      // Set brand
      const b_url = (urlData.get('brand') || '');
      this.input.brand = this.getDataset('brand').find(x => x.dashcase() == b_url.dashcase());

      // Set model
      this.input.model = this.getDataset('model').find(x => x == urlData.get('model'));      

      // Toggle fabric selector
      const smp = this.getDataset('selected-model-product');
      HardCodedValues.isDoubleLiner(smp) && (this.cache.fabric_selector_count = 2);

      // Fabrics
      for (const [k, v] of Object.entries(this.input)) {
        if (HardCodedValues.isFabric(k)) {
          this.input[k] = urlData.get(k) || urlData.get('fabric') || this.input[k] || '';

          this.input[k] && fetch(`/products/${(this.input[k]).dashcase()}.json`)
            .then(r => r.json())
            .then(r => {
              this.cache[k] = r.product.title;
              r.product.image.src && (document
                .querySelector(`input[name*="${k}"] + .swatch-image img`)
                .src = r.product.image.src);
            })
            .catch((error) => {
              //console.log(error)
            });
        }
      }
    },

  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  let count = 0;
  const detect = setInterval(() => {
      if(count == 10) { clearInterval(detect); }
      if(document.querySelectorAll('.xo-gallery video').length) {
        clearInterval(detect);
        document.querySelectorAll('.xo-gallery video').forEach((el, k) => {
          // start after 1s and play subsequently every 1s
          setTimeout(() => el.play(), (k * 2000) + 1000);
        });
      } else {
        count++;
      }
  });
});

// Hide Accordion when metafield is empty
const accordions = document.querySelectorAll('.accordion');
accordions?.forEach((accordion) => {
  const content = accordion.querySelector('.accordion__content');
  if (!content || content.innerHTML.trim() === '') {
    accordion.style.display = 'none';
  }
});

// Fabric Range : Product Popup
document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', e => {
    const el = e.target.closest('[data-fabric-card]');
    if (el) {
      e.preventDefault();
      document.querySelector('#QuickAdd-' + el.getAttribute('data-fabric-card'))?.show(el);
    }
  });
});

document.addEventListener('change', function(e) {
  if (e.target && e.target.name === 'attributes[Authority To Leave]') {
    const formData = new FormData();

    formData.append('attributes[Authority To Leave]', e.target.checked ? 'Yes' : 'No');
    fetch('/cart/update.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    })
    .then(response => response.json())
    .then(cart => {
       console.log('Cart updated with Authority To Leave:', cart);
    });
  }
});